import Style from './index.module.less'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ugeaToGea2, ugeaToGea3 } from '@/utils/number'
import { getFormatTimeZone, isEmptyOrNil } from '@/utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import AddressHash from '@/components/AddressHash'
import { useSearchParams } from 'react-router-dom'
import LoadingCom from '@/components/LoadingCom'
const Index = ({
  data,
  style = {},
  loading = false,
  network = '',
}: {
  style?: React.CSSProperties
  data?: any
  loading: boolean
  network: string
}) => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  const searchParams = useSearchParams()
  const netType = searchParams[0].get('net_type') || 'hub'

  const getAddress = () => {
    if (netType === 'hub') {
      return data?.tx_signer?.address || ''
    }
    return data?.tx_signers?.address
  }

  const handleJumpTo = () => {
    if (netType === 'hub') {
      if (data?.tx_signer?.address) {
        navigate(`/accountDetail/${data?.tx_signer?.address}`)
      }
    } else {
      if (data?.tx_signers?.address) {
        navigate(`/accountDetail/${data?.tx_signers?.address}`)
      }
    }
  }

  const getTime = () => {
    if (netType == 'hub') {
      if (data?.timestamp) {
        return getFormatTimeZone(data?.timestamp).currentTime
      }
      return '-'
    } else {
      if (data?.time?.timestamp) {
        return getFormatTimeZone(data?.time?.timestamp).currentTime
      }
      return '-'
    }
  }

  const getTimeUtc0 = () => {
    if (netType == 'hub') {
      if (data?.timestamp) {
        return getFormatTimeZone(data?.timestamp).timeUtc0
      }
      return '-'
    } else {
      if (data?.time?.timestamp) {
        return getFormatTimeZone(data?.time?.timestamp).timeUtc0
      }
      return '-'
    }
  }

  const getgGasLimit = () => {
    return data?.gas_limit || ' -'
  }

  const getGasFee = () => {
    if (netType == 'hub') {
      return ugeaToGea2(data?.gas_fee?.fee_amount)
    } else {
      // 确认rollup没有GAS_Fee
      return {
        value: '',
        sigin: '-',
      }
      // 这里返回了GAG要确认
      // if (data?.fee?.amount?.[0]?.denom == 'ugea') {
      //   return ugeaToGea3(data?.fee?.amount?.[0]?.amount, data?.fee?.amount?.[0]?.denom)
      // } else {
      //   return ugeaToGea2(data?.fee?.amount?.[0]?.amount)
      // }
    }
  }
  return (
    <div style={{ ...style }} className={Style.wrap}>
      {loading && <LoadingCom></LoadingCom>}
      <div className={classNames(Style.item, 'font_14')}>
        {/* 交易哈希 */}
        <span className="font_14">{t('explorer_103')}:</span>
        <div className={Style.textStyleOne}>
          <AddressHash data={data?.hash} copyIcon={'gray'} />
        </div>
      </div>
      {/* 网络
      <div className={classNames(Style.item, 'font_14')}>
        <span className="font_14">{t('explorer_283')}:</span>
        <div className={Style.textStyleOne}>
          <span>{t(network) || '-'}</span>
        </div>
      </div> */}
      <div className={classNames(Style.item, 'font_14')}>
        {/* 区块 */}
        <span className="font_14">{t('explorer_3')}:</span>
        <div className={Style.textStyleTwo}>
          {network === 'rollapp_checkin' ? (
            <AddressHash data={data?.height} />
          ) : (
            <AddressHash
              data={data?.height}
              handleJump={() => {
                navigate(`/blockchain/${data?.height}`)
              }}
            />
          )}
        </div>
      </div>
      <div className={classNames(Style.item, 'font_14', Style.itemStatus)}>
        {/* 状态 */}
        <span className="font_14">{t('explorer_53')}:</span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            [Style.textStatus]: true,
          })}
        >
          {isEmptyOrNil(data?.success) ? (
            '-'
          ) : (
            <>
              <span>{data?.success ? t('explorer_25') : t('explorer_222')}</span>
              <span className={classNames(data?.success ? Style.successIcon : Style.failedIcon)} />
            </>
          )}
        </div>
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* 发起者 */}
        <span className="font_14">{t('explorer_154')}:</span>
        <div className={Style.textStyleTwo}>
          {getAddress() ? (
            <AddressHash
              data={getAddress()}
              copyIcon={'gray'}
              handleJump={() => {
                handleJumpTo()
              }}
            ></AddressHash>
          ) : (
            <span className={Style.moData}>-</span>
          )}
        </div>
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* 当前时区 */}
        <span className="font_14">{t('explorer_95')}:</span>
        <div className={Style.textStyleOne}>
          <span>{getTime()}</span>
        </div>
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* UTC+0 */}
        <span className="font_14">UTC+0:</span>
        <div className={Style.textStyleOne}>
          <span>{getTimeUtc0()}</span>
        </div>
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* 备注 */}
        <span className="font_14">{t('explorer_155')}:</span>
        <div className={Style.textStyleOne}>{data?.memo || '-'}</div>
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* 已用 Gas: */}
        <span className="font_14">{t('explorer_156')}:</span>
        {data?.gas_used ? (
          <div className={Style.textStyleOne}>{data?.gas_used || '-'}</div>
        ) : (
          <div className={Style.textStyleOne}>-</div>
        )}
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* GasLimit */}
        <span className="font_14">GasLimit:</span>
        <div className={Style.textStyleOne}>{getgGasLimit()}</div>
      </div>
      <div className={classNames(Style.item, 'font_14')}>
        {/* GasFee */}
        <span className="font_14">GasFee:</span>
        <div className={Style.textStyleOne}>
          <span>{getGasFee().value}</span>
          <span className={Style.textStyleThree}> {getGasFee().sigin}</span>
        </div>
      </div>
    </div>
  )
}

export default Index
